// src/firebase.js
import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyDqPGJJyEVD45f5XL_ZMi9cq54SBcEwRrY",
  authDomain: "digiadashboadauth.firebaseapp.com",
  projectId: "digiadashboadauth",
  storageBucket: "digiadashboadauth.firebasestorage.app",
  messagingSenderId: "850013266209",
  appId: "1:850013266209:web:c81e62667bf81d108e5e60",
  measurementId: "G-M7G0260DXP"
}

const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()

// Only offer accounts on our own Google Workspace domain in the Google
// sign-in popup. This is a UX-level restriction only — the real
// enforcement is the server-side domain check on the backend.
googleProvider.setCustomParameters({ hd: 'digiadglobal.com' })

export { auth, googleProvider, signInWithPopup, signOut }

